// Design System "Technical Precision"
// Bordes solidos #E2E8F0, cabecera en label-caps sobre gris tecnico,
// filas a 12px vertical y hover #F1F5F9.
const Style = {

  table: 'w-full border-collapse table-auto',
  search: 'mb-4 md:mb-0',
  loading: 'relative py-8',
  badge: 'ml-0',
  empty: 'py-12 text-start text-on-surface-variant font-medium',
  thead: 'hidden md:table-header-group bg-surface-container',
  th_actions: 'text-right',

  th: `text-left outline-0 uppercase tracking-[0.05em] text-label-caps text-on-surface-variant
    px-4 py-2.5 border-b border-solid border-outline whitespace-nowrap`,

  sort: `relative cursor-pointer after:absolute after:right-0 after:top-1/2 after:mt-1
    after:w-3 after:h-3 after:opacity-50 after:-translate-y-1/2 after:bg-contain`,

  asc: `after:bg-[url('components/table/icons/ico-sort-asc.svg')]`,
  desc: `after:bg-[url('components/table/icons/ico-sort-dsc.svg')]`,

  cell: `float-left w-full p-0 mb-2 text-table-cell text-on-surface last:pb-4 last:border-b last:border-solid
    last:border-outline md:float-none md:w-auto md:mb-0 md:px-4 md:py-3 md:border-b md:border-solid
    md:border-outline md:whitespace-nowrap`,

  actions: `text-left float-left clear-left mb-4 whitespace-nowrap
  md:float-none md:clear-none md:text-right md:mb-0 border-b border-outline border-solid`,

  actionButton: 'inline-block whitespace-nowrap -top-1 mr-3 bg-transparent last:mr-0',
  scrollContainer: `overflow-x-auto overflow-y-hidden hide-scrollbar-x max-w-full`,

  // Indicadores de scroll
  scrollIndicatorContainer: 'relative overflow-hidden',
  scrollIndicatorLeft: 'absolute top-0 left-0 bottom-0 w-8 pointer-events-none z-10 opacity-0 transition-opacity duration-300',
  scrollIndicatorRight: 'absolute top-0 right-0 bottom-0 w-8 pointer-events-none z-10 opacity-0 transition-opacity duration-300',
  scrollIndicatorVisible: 'opacity-100',
  scrollHint: 'absolute right-3 top-1/2 transform -translate-y-1/2 text-on-surface-variant text-xs opacity-80 pointer-events-none z-15 animate-pulse font-medium',
  scrollHintHidden: 'opacity-0 transition-opacity duration-300',

  // Estilos para celdas con texto largo
  cellTruncate: 'max-w-xs truncate',
  cellTooltip: 'cursor-help',

  // Clases responsivas dinámicas (se aplicarán via props)
  hiddenMobile: 'hidden md:table-cell',
  hiddenTablet: 'hidden lg:table-cell',

}

export default Style;
